import { CrownIcon, WhatsAppIcon } from "@/components/Logo";

const WHATSAPP_URL =
  "https://wa.me/5513981197016?text=" +
  encodeURIComponent("Olá! Quero agendar um horário na Barbearia Salão Inovação.");

export default function Footer() {
  return (
    <footer className="border-t border-amber-500/10 px-6 py-12 text-center">
      <div className="flex justify-center">
        <CrownIcon size={26} />
      </div>
      <p className="mt-4 text-[10px] uppercase tracking-[0.45em] text-amber-500/60">
        Seu estilo. Sua identidade. Nossa paixão.
      </p>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-7 inline-flex items-center gap-2 rounded-full border border-[#25D366]/50 px-5 py-2.5 text-sm font-medium text-[#25D366] transition-colors duration-300 hover:bg-[#25D366]/10"
        data-testid="footer-whatsapp-link"
      >
        <WhatsAppIcon size={16} /> (13) 98119-7016
      </a>
      <p className="mt-9 text-[11px] leading-relaxed text-stone-600" data-testid="footer-copyright">
        © 2026 Barbearia Salão Inovação.
        <br />
        Todos os direitos reservados.
      </p>
    </footer>
  );
}
